import { CriteriaQuery, Criteria } from '@fpx/common/models';
import { Observable } from 'rxjs';

export class HttpRequest {
  private _headerParameters?: HttpParameter[] = [];
  private _queryParameters?: HttpParameter[] = [];
  private _pathParameters?: HttpParameter[] = [];
  private _body?: any = null;
  private _criteriaQuery?: Criteria;
  private _serverContext?: string = '';
  private _resource: string = '';
  private _method!: 'POST' | 'GET' | 'PUT' | 'DELETE';

  public addHeaderParamter(key: string, value: unknown): void {
    this._headerParameters?.push({ key: key, value: value });
  }
  public addQueryParameter(key: string, value: unknown): void {
    this._queryParameters?.push({ key: key, value: value });
  }
  public addPathParameter(key: string, value: unknown): void {
    this._pathParameters?.push({ key: key, value: value });
  }
  public setCriteriaQuery(criteriaQuery: CriteriaQuery): void {
    this._criteriaQuery = criteriaQuery.criteriaQuery();
  }
  public setBody(payload: unknown): void {
    this._body = payload;
  }
  public setResource(resourceUrl: string): void {
    this._resource = resourceUrl;
  }
  public setMethod(method: 'POST' | 'GET' | 'PUT' | 'DELETE'): void {
    this._method = method;
  }
  public setServerContext(serverContext: string): void {
    this._serverContext = serverContext;
  }

  get httpPayload(): HttpPayload {
    return {
      method: this._method,
      resource: this._resource,
      body: this._body,
      filterCriteria: this._criteriaQuery,
      pathParams: this._pathParameters,
      queryParams: this._queryParameters,
      headerParams: this._headerParameters,
      serverContext: this._serverContext,
    };
  }
}

export interface HttpParameter {
  key: string;
  value: any;
}
export interface HttpPayload {
  serverContext?: string;
  resource: string;
  method: 'POST' | 'GET' | 'PUT' | 'DELETE';
  pathParams?: HttpParameter[];
  queryParams?: HttpParameter[];
  headerParams?: HttpParameter[];
  body?: any;
  filterCriteria?: Criteria;
}

export declare interface CreateFn<T> {
  (): Observable<T>;
}

export declare interface ModifyFn<T> {
  (): Observable<T>;
}

export declare interface FindAllFn<T> {
  (): Observable<T>;
}

export declare interface FindByKeyFn<T> {
  (): Observable<T>;
}

export declare interface LookUpFn<T> {
  (): Observable<any>;
}

export declare interface GridTransformFn<T> {
  (payload:T) : any
}
